import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState } from "react";
import { getOptionsFromWindow, getOtherOptionsFromWindow } from "../utils";
import { useBannerPreDecisionGateway, useTcf } from "../hooks";
import { applyConsent, getCookieConsentManager } from "../others";
import { prepareTcfString } from "../tcf";
import { getUserDecision } from "@devowl-wp/cookie-consent-web-client";
import { useBannerConsentListener } from "@devowl-wp/react-cookie-banner";
import { BannerContextFactory, useBannerToggleOverlay, Banner, useBannerStateContextCallbacks } from "@devowl-wp/react-cookie-banner";
import { locationRestConsentGet } from "../wp-api";
import { commonRequest } from "@devowl-wp/utils";
import { BannerProductionNotice } from ".";
/**
 * Simply connects a context store to the banner itself. On the website itself
 * it should not rely
 */

var WebsiteBanner = function WebsiteBanner(_ref) {
  var poweredLink = _ref.poweredLink;

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      _getOtherOptionsFromW2 = _getOtherOptionsFromW.customizeValuesBanner,
      layout = _getOtherOptionsFromW2.layout,
      decision = _getOtherOptionsFromW2.decision,
      legal = _getOtherOptionsFromW2.legal,
      design = _getOtherOptionsFromW2.design,
      headerDesign = _getOtherOptionsFromW2.headerDesign,
      bodyDesign = _getOtherOptionsFromW2.bodyDesign,
      footerDesign = _getOtherOptionsFromW2.footerDesign,
      texts = _getOtherOptionsFromW2.texts,
      individualLayout = _getOtherOptionsFromW2.individualLayout,
      saveButton = _getOtherOptionsFromW2.saveButton,
      group = _getOtherOptionsFromW2.group,
      individualTexts = _getOtherOptionsFromW2.individualTexts,
      customCss = _getOtherOptionsFromW2.customCss,
      mobile = _getOtherOptionsFromW2.mobile,
      pageId = _getOtherOptionsFromW.pageId,
      pageRequestUuid4 = _getOtherOptionsFromW.pageRequestUuid4,
      pageIdToPermalink = _getOtherOptionsFromW.pageIdToPermalink,
      consentForwardingExternalHosts = _getOtherOptionsFromW.consentForwardingExternalHosts,
      essentialGroup = _getOtherOptionsFromW.essentialGroup,
      isTcf = _getOtherOptionsFromW.isTcf,
      isEPrivacyUSA = _getOtherOptionsFromW.isEPrivacyUSA,
      isAgeNotice = _getOtherOptionsFromW.isAgeNotice,
      isListServicesNotice = _getOtherOptionsFromW.isListServicesNotice,
      tcf = _getOtherOptionsFromW.tcf,
      tcfMetadata = _getOtherOptionsFromW.tcfMetadata,
      groups = _getOtherOptionsFromW.groups,
      isRefreshSiteAfterConsent = _getOtherOptionsFromW.isRefreshSiteAfterConsent,
      userConsentCookieName = _getOtherOptionsFromW.userConsentCookieName,
      bannerI18n = _getOtherOptionsFromW.bannerI18n,
      affiliate = _getOtherOptionsFromW.affiliate,
      isCurrentlyInTranslationEditorPreview = _getOtherOptionsFromW.isCurrentlyInTranslationEditorPreview,
      pageByIdUrl = _getOtherOptionsFromW.pageByIdUrl;

  var userDecision = getUserDecision(userConsentCookieName); // TCF compatibility

  var tcfObject = useTcf(isTcf, tcf, tcfMetadata); // Server-side rendered overlay handler

  var _useBannerToggleOverl = useBannerToggleOverlay(document.getElementById(pageRequestUuid4)),
      toggleOverlay = _useBannerToggleOverl.toggleOverlay;

  var _useBannerStateContex = useBannerStateContextCallbacks({
    toggleOverlay: toggleOverlay,
    revokeConsent: function revokeConsent(_ref2) {
      var tcf = _ref2.tcf;
      // Do not rely on current state of `groups` because it can be altered through history change
      var buttonClicked = "shortcode_revoke"; // TCF compatibility: revoke TCF string

      // TCF compatibility: revoke TCF string
      var tcfString;

      if (process.env.IS_TCF === "1" && tcf !== null && tcf !== void 0 && tcf.model) {
        tcfString = prepareTcfString(tcf.model, buttonClicked);
      }

      return applyConsent({
        consent: {
          groups: getCookieConsentManager().getDefaultDecision(true)
        },
        buttonClicked: buttonClicked,
        tcfString: tcfString
      });
    }
  }),
      _openHistory = _useBannerStateContex.openHistory,
      _openBanner = _useBannerStateContex.openBanner,
      _revokeConsent = _useBannerStateContex.revokeConsent,
      _updateTcfFilterBy = _useBannerStateContex.updateTcfFilterBy,
      _updateIndividualPrivacyOpen = _useBannerStateContex.updateIndividualPrivacyOpen,
      _updateGroupChecked = _useBannerStateContex.updateGroupChecked,
      _updateCookieChecked = _useBannerStateContex.updateCookieChecked,
      _onClose = _useBannerStateContex.onClose,
      _selectHistoryEntry = _useBannerStateContex.selectHistoryEntry; // Context values preparation


  var _useState = useState({
    layout: _objectSpread({}, layout),
    decision: _objectSpread({}, decision),
    legal: _objectSpread({}, legal),
    design: _objectSpread({}, design),
    headerDesign: _objectSpread({}, headerDesign),
    bodyDesign: _objectSpread({}, bodyDesign),
    footerDesign: _objectSpread({}, footerDesign),
    texts: _objectSpread({}, texts),
    individualLayout: _objectSpread({}, individualLayout),
    saveButton: _objectSpread({}, saveButton),
    group: _objectSpread({}, group),
    individualTexts: _objectSpread({}, individualTexts),
    customCss: _objectSpread({}, customCss),
    mobile: _objectSpread({}, mobile),
    productionNotice: h(BannerProductionNotice, null),
    pageRequestUuid4: pageRequestUuid4,
    pageIdToPermalink: pageIdToPermalink,
    pageByIdUrl: pageByIdUrl,
    consentForwardingExternalHosts: consentForwardingExternalHosts,
    pageId: pageId,
    isTcf: isTcf,
    ePrivacyUSA: isEPrivacyUSA,
    ageNotice: isAgeNotice,
    listServicesNotice: isListServicesNotice,
    tcf: tcfObject,
    tcfFilterBy: "legInt",
    groups: groups,
    essentialGroup: essentialGroup,
    poweredLink: poweredLink,
    visible: false,
    animationVisible: true,
    skipOverlay: true,
    previewCheckboxActiveState: false,
    individualPrivacyOpen: false,
    i18n: bannerI18n,
    keepVariablesInTexts: isCurrentlyInTranslationEditorPreview,
    affiliate: affiliate,
    consent: {
      groups: _objectSpread(_objectSpread({}, userDecision === false ? {} : userDecision.consent), getCookieConsentManager().getDefaultDecision(userDecision === false))
    },
    didGroupFirstChange: false,
    onSave: function onSave(markAsDoNotTrack, buttonClicked) {
      setContextValue(function (state) {
        var _state$tcf;

        // TCF compatibility: persist TCF string
        var tcfString;

        if (process.env.IS_TCF === "1" && isTcf && (_state$tcf = state.tcf) !== null && _state$tcf !== void 0 && _state$tcf.model) {
          tcfString = prepareTcfString(state.tcf.model, buttonClicked);
        }

        var appliedConsent = applyConsent({
          consent: state.consent,
          markAsDoNotTrack: markAsDoNotTrack,
          buttonClicked: buttonClicked,
          tcfString: tcfString
        });

        if (isRefreshSiteAfterConsent || state.refreshSiteAfterSave) {
          appliedConsent.then(function () {
            return (// Fix iOS / Safari bug when we want to reload the page after a POST request
              setTimeout(function () {
                return window.location.reload();
              }, state.refreshSiteAfterSave ||
              /* BC */
              2000)
            );
          }); // When refreshing the site, do not show any out animation

          // When refreshing the site, do not show any out animation
          return state;
        } else {
          return _objectSpread(_objectSpread({}, state), toggleOverlay(state, false));
        }
      });
    },
    fetchHistory: function () {
      var _fetchHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _getOptionsFromWindow, restNamespace, restRoot, restQuery, restNonce, history;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _getOptionsFromWindow = getOptionsFromWindow(), restNamespace = _getOptionsFromWindow.restNamespace, restRoot = _getOptionsFromWindow.restRoot, restQuery = _getOptionsFromWindow.restQuery, restNonce = _getOptionsFromWindow.restNonce;
                _context.next = 3;
                return commonRequest({
                  location: locationRestConsentGet,
                  options: {
                    restNamespace: restNamespace,
                    restRoot: restRoot,
                    restQuery: restQuery,
                    restNonce: restNonce
                  },
                  sendRestNonce: false
                });

              case 3:
                history = _context.sent;
                setContextValue(function (state) {
                  return _objectSpread(_objectSpread({}, state), {}, {
                    history: history
                  });
                });
                return _context.abrupt("return", history);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchHistory() {
        return _fetchHistory.apply(this, arguments);
      }

      return fetchHistory;
    }(),
    // Predefined callbacks
    updateTcfFilterBy: function updateTcfFilterBy(newFilter) {
      return _updateTcfFilterBy(setContextValue, newFilter);
    },
    updateIndividualPrivacyOpen: function updateIndividualPrivacyOpen(opened) {
      return _updateIndividualPrivacyOpen(setContextValue, opened);
    },
    updateGroupChecked: function updateGroupChecked(id, checked) {
      return _updateGroupChecked(setContextValue, id, checked);
    },
    updateCookieChecked: function updateCookieChecked(groupId, id, checked) {
      return _updateCookieChecked(setContextValue, groupId, id, checked);
    },
    onClose: function onClose() {
      return _onClose(setContextValue);
    },
    selectHistoryEntry: function selectHistoryEntry(groups, consentGroups, tcf) {
      return _selectHistoryEntry(setContextValue, groups, consentGroups, tcf);
    },
    openHistory: function openHistory(e) {
      return _openHistory(setContextValue, e);
    },
    openBanner: function openBanner(e) {
      return _openBanner(setContextValue, e);
    },
    revokeConsent: function revokeConsent(successMessage, e) {
      return _revokeConsent(setContextValue, successMessage, e);
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      contextValue = _useState2[0],
      setContextValue = _useState2[1];

  useBannerPreDecisionGateway(contextValue, setContextValue, toggleOverlay);
  useBannerConsentListener(setContextValue, userConsentCookieName);
  var BannerContext = BannerContextFactory.Context();
  return h(BannerContext.Provider, {
    value: contextValue
  }, h(Banner, null));
};

export { WebsiteBanner };